// if the experiencecenter exists run this scripting
var $ = jQuery;
$(document).ready(function(){

  AOS.init();
  if($("#experiencecenter").length){
    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var scrollTimer;
    $(window).bind('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          //footer
          var test = $('#show_experience').isInViewport();
          if(test)
          {
              $('#experiencecenter .hidden').removeClass('hidden');
          }
        },100);
    });
  }
  if($('#HomeHeader').length)
  {
      var video = $('#bgvid').get(0);
      $('#video_controls #pause').click(function(){
        $('#video_controls .active').removeClass('active');
        $(this).addClass('active');
        video.pause();
      });
      $('#video_controls #play').click(function(){
        $('#video_controls .active').removeClass('active');
        $(this).addClass('active');
        video.play();
      });
  }




});
